import { render, staticRenderFns } from "./PartyDetailsModal.vue?vue&type=template&id=5c5bcfb9"
import script from "./PartyDetailsModal.vue?vue&type=script&lang=js"
export * from "./PartyDetailsModal.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports